var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadarRules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.80469L18.5322 3.4785C18.9516 3.57171 19.25 3.9437 19.25 4.37334V13.5278C19.25 15.3668 18.3309 17.0841 16.8008 18.1041L11 21.9714L5.19915 18.1041C3.66906 17.0841 2.75 15.3668 2.75 13.5278V4.37334C2.75 3.9437 3.0484 3.57171 3.46781 3.4785L11 1.80469ZM11 3.68274L4.58333 5.10867V13.5278C4.58333 14.7538 5.19603 15.8986 6.2161 16.5787L11 19.768L15.7839 16.5787C16.804 15.8986 17.4167 14.7538 17.4167 13.5278V5.10867L11 3.68274ZM15.0814 8.4247L16.3777 9.72106L10.544 15.5547L6.65499 11.6656L7.95136 10.3692L10.5434 12.9613L15.0814 8.4247Z",
    fill: "#251169"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadarRules);
export default __webpack_public_path__ + "static/media/radar_rules.f6765f031aa5e298fbf1463c599ab9ca.svg";
export { ForwardRef as ReactComponent };